import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Header from '../components/header';
import Footer from '../components/footer';

import '../../sass/style.scss';

const TemplateWrapper = (props) => {
	//console.log('en wrapper', props);
	return (
  <div>
    <Helmet
      title={props.data.allDataJson.edges[0].node.en[0].title}
    />
    <Header data={props.data.allDataJson.edges[0].node.en[0].parts} langu="es"/>
    
    
    
     {props.children()}
    <Footer />
  </div>
)};

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;

export const pageQuery = graphql`
  query IndexQueryOther {
    allDataJson {
      edges {
        node {
          en {
            title
            parts {
	            content
	            title
	            image
	            link 
	            social
	            id
	            list
	          } 
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/layouts/en.js